// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // base_url: "http://202.131.117.92:7882/",
  base_url: "https://elderly-smile-python.agiletechnologies.in/",
  // base_url: "https://apielderly.agilesoftwares.com/",
  stripe_key: "pk_test_04kKRu5EXcxiHYMZyFM7yxIQ00mq36dm9O",
  apiKey: "AIzaSyCn_yaup-fgkmTgbRL8iV3oJKl_pYxTRO0",
};
